import { axiosInstance } from "@helpers/axios-instance";
import { useMutationWithValidation } from "./useMutationWithValidation";

export const useHouseholdDataUpdate = <T extends object>(objectId: string, type: string) => {
  return useMutationWithValidation({
    mutationFn: async (data: T) => {
      const response = await axiosInstance({
        method: "POST",
        data,
        url:  `Household/Data/${type}/${objectId}`,
      });
      return response.data;
    },
    retry: 2,
  });
};
